// extracted by mini-css-extract-plugin
module.exports = {"loadmoreButton":"gdds-loadmore-button_loadmoreButton__yMzkm"};